import { getStore } from '../store/store';
import { getPendingGetStartedTaskCount } from './getPendingGetStartedTaskCount';

export function getCompletionPercentage(): number {
    const store = getStore();
    let completionPercentage = 0;

    if (store.tasks) {
        const totalTaskCount = Object.keys(store.tasks).length;
        const pendingTaskCount = getPendingGetStartedTaskCount();

        if (pendingTaskCount > 0) {
            completionPercentage = (totalTaskCount - pendingTaskCount) / totalTaskCount;
        } else {
            completionPercentage = 1;
        }
    }

    return completionPercentage;
}
